import connect from 'react-redux/es/connect/connect';
import { I18n } from 'react-redux-i18n';

import ProfileFormatsManagement from '../components/ProfileFormatsManagement';
import * as actions from '../actions/UserDetailsActions';
import * as mainActions from '../actions';
import { MessageBoxTypes } from '../const/ActionsConst';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (name, data) => {
            dispatch(actions.updateProfile(name, data));
        },
        onCreate: (name) => {
            dispatch(actions.createProfile(name));
        },
        onDelete: (formats, callback) => dispatch(
            mainActions.showMessageBoxBasedOnData(
                MessageBoxTypes.DELETE_PROFILE_FORMATS, 
                true, 
                I18n.t('Delete Profile Format'), 
                I18n.t('Are you sure you want to delete all selected profile formats?'), 
                I18n.t('Delete Format'),
                I18n.t('Cancel'), 
                'small',
                { formats },
                callback
            )
        ),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileFormatsManagement);

